var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLongRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 9,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M37.354 4.854a.5.5 0 0 0 0-.708L34.172.964a.5.5 0 1 0-.707.708L36.293 4.5l-2.828 2.828a.5.5 0 1 0 .707.708l3.182-3.182ZM0 5h37V4H0v1Z",
  fill: "#BAA57E"
})));
export default SvgArrowLongRight;